const e = /* @__PURE__ */ new WeakSet();
export {
  e as isPressing
};
